<template>
  <div class="wt2-dashboard-in-progress wt2-breakpoints">
    <div class="-panel">
      <div class="-control-group">
        <div class="wt2-text-2xl">{{ 'dashboardDrafts.title' | culture }}</div>
        <div class="-control">
          <wt-search
            :value="this.$store.getters.storiesFilters.q"
            @input="searchQuery"
          />
        </div>
      </div>
      <div class="-control-group">
        <div v-if="showBrandsList" class="-control -control-programmers">
          <wt-dropdown
            type="normal right"
            :items="brandsList"
            :on-click-item="setBrand"
            :current-item-id="currentBrandMixedId"
            class="wt2-programmers-dropdown align-self-center"
          />
        </div>
        <div class="-control">
          <wt-toggle
            :label-left="'dashboardDrafts.myWork' | culture"
            v-model="$store.state.dashboard.myWork.stories"
            :disabled="isFetching"
            @toggle="refreshCurrentList"
          />
        </div>
      </div>
    </div>

    <wt-continuous-pagination
      v-if="!isEmpty"
      class="-content"
      :on-next-page="onNextPage"
    >
      <ul class="wt2-story-previews list-inline">
        <template v-for="entry in groupedStories">
          <story-preview-item
            v-if="entry.story"
            :key="entry.key"
            :story="entry.story"
            tab="In Progress"
          />
          <story-preview-group
            v-else
            :key="entry.key"
            :members="entry.members"
            :folder-id="entry.folderId"
            tab="In Progress"
          />
        </template>
      </ul>
    </wt-continuous-pagination>

    <div class="-empty-state-box" v-if="isEmpty">
      <div v-if="hasDefaultStoriesFilters" class="-centered">
        <img src="/resources/img/empty_in_progress.png" />
        <div class="-title">{{ 'dashboardDrafts.empty1' | culture }}</div>
      </div>
      <div v-else class="-centered">
        <img src="/resources/img/empty_no_results.png" />
        <div class="-title">{{ 'dashboardDrafts.emptySearch1' | culture }}</div>
        <div class="-message">
          {{ 'dashboardDrafts.emptySearch2' | culture }}
        </div>
      </div>
    </div>

    <div class="wt-dashboard-loader" v-show="isFetching">
      <div class="wt-loader"></div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import StoryPreviewItem from 'v/Dashboard/StoryPreviewItem.vue';
import StoryPreviewGroup from 'v/Dashboard/StoryPreviewGroup.vue';
import Analytics from 'c/WtAnalytics';
import { mapGetters } from 'vuex';

export default {
  components: {
    StoryPreviewItem,
    StoryPreviewGroup,
  },

  data() {
    return {};
  },

  created() {
    this.$store.getters.storiesFilters.q = '';
    this.refreshCurrentList({ bReset: false });
  },

  beforeDestroy() {},

  mounted() {},

  computed: {
    ...mapGetters(['stories', 'groupedStories', 'hasDefaultStoriesFilters']),
    ...mapGetters('user', ['selectedOrganization']),

    isFetching() {
      return this.$store.getters.fetching.stories;
    },

    isEmpty() {
      return this.$store.state.dashboard.hasEmpty.stories && !this.isFetching;
    },

    showBrandsList() {
      return this.selectedOrganizationBrands.length > 1;
    },

    selectedOrganizationBrands() {
      return this.selectedOrganization.brands.map((brand) => ({
        id: brand._mixedId,
        label: brand.name,
      }));
    },

    brandsList() {
      return [
        {
          id: null,
          label: app.culture.dashboardFilter.allBrands,
        },
        ...this.selectedOrganizationBrands,
      ];
    },

    currentBrandMixedId() {
      const { brandId, programmerId } = this.$store.getters.storiesFilters;
      return (
        this.selectedOrganization.brands.find(
          (brand) =>
            brand.brandId === brandId && brand.programmerId === programmerId
        )?._mixedId || null
      );
    },
  },

  watch: {
    '$store.state.dashboard.myWork.stories': function (myWorkState) {
      this.$emit('filterschange', {
        filter: myWorkState ? 'My Work On' : 'My Work Off',
      });
    },
  },

  methods: {
    refreshCurrentList(options) {
      return this.$store.dispatch('fetchStories', options);
    },

    setBrand(mixedId) {
      const brand = this.selectedOrganization.brands.find(
        (brand) => brand._mixedId === mixedId
      );
      this.$store.getters.storiesFilters.brandId = brand?.brandId || null;
      this.$store.getters.storiesFilters.programmerId =
        brand?.programmerId || null;
      this.refreshCurrentList();
      this.$emit('filterschange', { filter: 'Production Line' });
    },

    searchQuery(str) {
      Analytics.trigger('analytics:dashboard:search', {
        tab: 'Dashboard In Progress',
      });
      this.$store.getters.storiesFilters.q = str;
      this.refreshCurrentList();
    },

    onNextPage: _.debounce(
      function () {
        this.refreshCurrentList({ bReset: false, bFetchMore: true });
      },
      app.TIME.MENTAL.VISUAL,
      { leading: true, trailing: false, maxWait: app.TIME.MENTAL.VISUAL }
    ),
  },
};
</script>
